import { render, staticRenderFns } from "./airProcNew.vue?vue&type=template&id=1f65a30e&scoped=true"
import script from "./airProcNew.vue?vue&type=script&lang=js"
export * from "./airProcNew.vue?vue&type=script&lang=js"
import style0 from "./airProcNew.vue?vue&type=style&index=0&id=1f65a30e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f65a30e",
  null
  
)

export default component.exports